// src/customer/customer-policy/customer-policy-commission/DirectBillRecord.tsx

import React from "react";
import { Panel, Row, Column } from "../../../components";
import { Badge } from "primereact/badge";
import { FloatingLabel, Form } from "react-bootstrap";
import { IDirectBillRecordData } from "./models/CommissionTypes";
import { fomratWithCommasAndDecimals } from "../../../shared/util/currencyUtils";
import { rateOrEmpty } from "./commissionFormatters";

interface IDirectBillRecordProps {
  data: IDirectBillRecordData;
  transEffectiveDate: string;
}

const DirectBillRecord: React.FC<IDirectBillRecordProps> = ({
  data,
  transEffectiveDate,
}) => {
  return (
    <Panel
      title="TRANSACTION DETAILS"
      className="commission-panel-header"
      panelHeaderItems={
        <>
          {data.badges.map((badge, index) => (
            <Badge key={index} severity="info" value={badge} className="p-badge p-component p-badge-no-gutter ul-truncate-p-badge" />
          ))}
          <span className="commission-card-date ms-auto">
            TRANS EFFECTIVE DATE {transEffectiveDate}
          </span>
        </>
      }
    >
      <Row className="mb-3">
          <Column lg={6} md={6}>
            <FloatingLabel controlId="premium" label="Premium">
              <Form.Control
                type="text"
                name="premium"
                value={`$${fomratWithCommasAndDecimals(data.premium)}`}
                placeholder="Premium"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
          <Column lg={6} md={6}>
            <FloatingLabel controlId="billedPremium" label="Billed Premium">
              <Form.Control
                type="text"
                name="billedPremium"
                value={`$${fomratWithCommasAndDecimals(data.billedPremium)}`}
                placeholder="Billed Premium"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
        </Row>
        <Row className="mb-3">
          <Column lg={6} md={6}>
            <FloatingLabel controlId="writtenPremium" label="Written Premium">
              <Form.Control
                type="text"
                name="writtenPremium"
                value={`$${fomratWithCommasAndDecimals(data.writtenPremium)}`}
                placeholder="Written Premium"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
          <Column lg={6} md={6}>
            <FloatingLabel controlId="fullTermPremium" label="Full Term Premium">
              <Form.Control
                type="text"
                name="fullTermPremium"
                value={`$${fomratWithCommasAndDecimals(data.fullTermPremium)}`}
                placeholder="Full Term Premium"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
        </Row>
        <Row className="mb-3">
          <Column lg={6} md={6}>
            <FloatingLabel controlId="includePremium" label="Include Premium">
              <Form.Control
                type="text"
                name="includePremium"
                value={`$${fomratWithCommasAndDecimals(data.includePremium)}`}
                placeholder="Include Premium"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
        </Row>

        {/* Commissions Section */}
        <h6 className="commission-section-header roboto-condensed-bold">COMMISSIONS</h6>
        <Row className="mb-3">
          <Column lg={6} md={6}>
            <FloatingLabel controlId="ivansCommissionRate1" label="Commission Rate 1">
              <Form.Control
                type="text"
                name="ivansCommissionRate1"
                value={rateOrEmpty(data.commissionRate1)}
                placeholder="Commission Rate 1"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
          <Column lg={6} md={6}>
            <FloatingLabel controlId="ivansCommissionRate2" label="Commission Rate 2">
              <Form.Control
                type="text"
                name="ivansCommissionRate2"
                value={rateOrEmpty(data.commissionRate2)}
                placeholder="Commission Rate 2"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
        </Row>
        <Row className="mb-3">
          <Column lg={6} md={6}>
            <FloatingLabel controlId="ivansCompensationRate" label="Compensation Rate">
              <Form.Control
                type="text"
                name="ivansCompensationRate"
                value={rateOrEmpty(data.compensationRate)}
                placeholder="Compensation Rate"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
          <Column lg={6} md={6}>
            <FloatingLabel controlId="ivansCommission" label="Commission">
              <Form.Control
                type="text"
                name="ivansCommission"
                value={`$${fomratWithCommasAndDecimals(data.commission)}`}
                placeholder="Commission"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
        </Row>
        <Row>
          <Column lg={6} md={6}>
            <FloatingLabel controlId="ivansCompensation" label="Compensation">
              <Form.Control
                type="text"
                name="ivansCompensation"
                value={`$${fomratWithCommasAndDecimals(data.compensation)}`}
                placeholder="Compensation"
                onChange={() => {}}
              />
            </FloatingLabel>
          </Column>
        </Row>
    </Panel>
  );
};

export default DirectBillRecord;
